import { LogList } from './logs/LogList';
import { LogShow } from './logs/LogShow';
import { History as LogsIcon } from '@mui/icons-material';

export const NotificationLogs = {
    list: LogList,
    show: LogShow,
    icon: LogsIcon,
};